import { useEffect } from 'react';

import { useAppSelector } from './react-redux';
import { DocumentThemePreference } from '../components/auth/login/store';
import { getCurrentUserDefaults } from '../components/home/store/selectors';

export const useDocumentThemePreference = () => {
    const { documentThemePreference } = useAppSelector(getCurrentUserDefaults);

    useEffect(() => {
        const localStorageDocumentTheme = (localStorage.getItem('documentTheme') as DocumentThemePreference | undefined);
        if (localStorageDocumentTheme !== documentThemePreference) {
            localStorage.setItem('documentTheme', documentThemePreference);
            document.querySelector('html')?.setAttribute('document-viewer-theme', documentThemePreference);
        }
    }, [documentThemePreference]);
};
